import { StatusLabelPipe } from '../pipes/StatusLabelPipe';
import * as _ from 'lodash';

export const StatusEnum = Object.freeze({
    ALL: 'ALL',
    DISMISSED: 'DISMISSED',
    ACTIVE: 'ACTIVE'
});

export const makeStatusOptions = () =>
    _.map(StatusEnum, (value, key) => ({
        label: StatusLabelPipe(key),
        value
    }));

// todo: Temporary solution until dismissType filtering is fixed on the BE
export const getStatusAsBoolean = status => {
    switch (status) {
        case StatusEnum.DISMISSED:
            return true;
        case StatusEnum.ACTIVE:
            return false;
        case StatusEnum.ALL:
        default:
            return null;
    }
};
